/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import Page from '../../Components/Page/Page.component';
import withServices from '../../Contexts/Services/WithServices.context';
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import LayoutsPagePropTypes from './Layouts.page.props';
import layoutsPageStyles from './Layouts.page.styles';
import PageGenericSidebar from './PageGenericSidebar.page.sidebar';
/**
 * LayoutTemplate1PageComponent
 * @export
 * @class LayoutTemplate1PageComponent
 * @extends {React.Component<LayoutTemplate1PageComponentComposedProps, LayoutTemplate1PageComponentState>}
 */
class PageLargeTopBarComponent extends Component {
  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderConcreteDeliveriesPageComponent
   */
  static propTypes = LayoutsPagePropTypes;

  /**
   * Render the component
   * @returns {React.Component} The rendered `<LayoutTemplate2Page />`
   * @memberof PageLargeTopBarComponent
   */
  render() {
    const { children, classes, overflow, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    return (
      <Page
			className={`${classes.root} ${this.props.className || ''}`} // Ensure it applies custom styles
        hideLogo={isSmall}
        hideMenuIcon={isLarge}
        overflow={overflow || `auto`}
        sidebarContent={<PageGenericSidebar />}
        {...this.props}
      >
        {children}
      </Page>
    );
  }
}

const PageLargeTopBar = compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...sidebarActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(layoutsPageStyles), { withTheme: true }),
)(PageLargeTopBarComponent);

export default PageLargeTopBar;
